import AccountService from './AccountService';
import { track as analyticsServiceTrack, EVENTS, SOURCES } from './AnalyticsService';
import * as AuthenticationService from './AuthenticationService';
import ChangelogService from './ChangelogService';
import * as CommandService from './CommandService';
import { getConfig } from './ConfigurationService';
import ConsentService from './ConsentService';
import customerMeetingService from './CustomerMeetingService';
import EventBusService from './EventBusService';
import * as FeatureFlagsService from './FeatureFlagService';
import * as HelpVideoService from './HelpVideoService';
import HelpWidgetService from './HelpWidgetService';
import HintService from './HintService';
import HistoryService, { history as historyV5 } from './HistoryService';
import * as HotjarService from './HotjarService';
import InAppChatService from './InAppChatService';
import InAppSalesChatService from './InAppSalesChatService';
import LegacyFeatureFlagsService from './LegacyFeatureFlagsService';
import LegacyJavascriptTranslationService from './LegacyJavascriptTranslationService';
import {
  getPreferenceFromLocalStorageForCurrentUser,
  savePreferenceToLocalStorageForCurrentUser,
  removePreferenceFromLocalStorageForUser,
} from './LocalStorageService';
import LocationService from './LocationService';
import LoggingService from './LoggingService';
import ManifestService from './ManifestService';
import MicroAppsService from './MicroAppsService';
import NavigationService from './NavigationService';
import NotificationsService from './NotificationsService';
import OnboardingService from './OnboardingService';
import PopupsService from './PopupsService';
import PreferencesService from './PreferencesService';
import RepeatedActionService from './RepeatedActionService';
import SampleDataService from './SampleDataService';
import { getPreferenceFromSessionStorage, savePreferenceToSessionStorage } from './SessionStorageService';
import TeamleaderContactService from './TeamleaderContactService';
import { track as trackingServiceTrack } from './TrackingService';
import UrlGeneratorService from './UrlGeneratorService';
import UsersnapService from './UsersnapService';

const configuration = {
  getConfig,
};

const localStorage = {
  getPreferenceFromLocalStorageForCurrentUser,
  savePreferenceToLocalStorageForCurrentUser,
  removePreferenceFromLocalStorageForUser,
};

const sessionStorage = {
  getPreferenceFromSessionStorage: getPreferenceFromSessionStorage,
  savePreferenceToSessionStorage: savePreferenceToSessionStorage,
};

const tracking = {
  track: trackingServiceTrack,
};

const analytics = {
  track: analyticsServiceTrack,
  EVENTS,
  SOURCES,
};

const services = {
  authentication: AuthenticationService,
  configuration,
  consent: ConsentService,
  logging: LoggingService,
  localStorage,
  tracking,
  analytics,
  featureFlags: FeatureFlagsService,
  legacyFeatureFlags: LegacyFeatureFlagsService,
  urlGenerator: UrlGeneratorService,
  sessionStorage,
  popups: PopupsService,
  preferences: PreferencesService,
  notifications: NotificationsService,
  microApps: MicroAppsService,
  manifest: ManifestService,
  location: LocationService,
  eventBus: EventBusService,
  inAppChat: InAppChatService,
  inAppSalesChat: InAppSalesChatService,
  navigation: NavigationService,
  hotjar: HotjarService,
  helpWidget: HelpWidgetService,
  usersnap: UsersnapService,
  helpVideoService: HelpVideoService,
  account: AccountService,
  teamleaderContact: TeamleaderContactService,
  changelog: ChangelogService,
  sampleData: SampleDataService,
  onboarding: OnboardingService,
  actions: RepeatedActionService,
  history: HistoryService,
  historyV5,
  legacyTranslations: LegacyJavascriptTranslationService,
  command: CommandService,
  customerMeeting: customerMeetingService,
  hint: HintService,
};

export default services;
